import { t } from 'i18next'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import React, { useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { ProfileForm } from './ProfileForm'
import { API_PROFILE } from '../../../../../constants'
import i18n from '../../../../../i18n'
import {
  RequestMethod,
  UserAccountType,
} from '../../../../../model/enums/enums'
import { Person } from '../../../../../model/person.model'
import { apprenticeUpdated } from '../../../../../redux/basic/apprentice/apprenticeReducer'
import { employeeUpdated } from '../../../../../redux/basic/employee/employeeReducer'
import { useAppDispatch } from '../../../../../redux/hooks'
import { handleRequest } from '../../../../../services/api/base/handleRequest'
import { Phone } from '../../../../../util/phone'
import {
  showCheckMarkToast,
  showErrorToast,
} from '../../../../util/checkmark-toast/CheckmarkToast'
import { EditViewProps } from '../interfaces/EditViewProps'

export const EditView = (props: EditViewProps) => {
  const { person, company } = props
  const [phoneNumbersToRemove] = useState(new Array<Phone>())
  const defaultValues = { ...person, company_name: company?.company_name }
  const methods = useForm<Person>({ defaultValues: defaultValues })
  const toast = useRef<Toast>(null)

  const dispatcher = useAppDispatch()

  const onSubmit = async (validData: Person) => {
    const phoneArray = validData.phone ? validData.phone : []

    phoneNumbersToRemove.map((phone: Phone) => {
      phone.delete = true
      phoneArray.push(phone)
    })

    if (validData?.person_id != undefined) {
      const p = { ...validData, phone: phoneArray }

      const response = await handleRequest<Person>(
        API_PROFILE(),
        RequestMethod.PUT,
        p
      )
      if (!response.error && response.data) {
        showCheckMarkToast(toast)
        // in case of success go back to static view
        props.onSaveButtonClick()
        if (validData.user_account_type === UserAccountType.Apprentice) {
          dispatcher(apprenticeUpdated(response.data))
          return
        }
        dispatcher(employeeUpdated(response.data))
      } else {
        // in case of an error stay on the view and inform the user
        console.warn('[Profile edit] Failed to edit.')
        showErrorToast(
          toast,
          t<string>('core.action.failed.title'),
          t<string>('core.action.failed.message')
        )
      }
    }
  }

  const onCancel = () => {
    // todo open prompt informing about data loss due to unsaved changes
    props.onCancelButtonClick()
  }

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <ProfileForm phoneNumbersToRemove={phoneNumbersToRemove} />
          <div className={'flex flex-wrap m-2 mt-3'}>
            <Button
              type="button"
              className={'field lg:col-2 col-12 p-button-outlined mr-2 ml-auto'}
              label={i18n.t<string>('core.cancel')}
              onClick={onCancel}
            />
            <Button
              type="submit"
              className={'field lg:col-2 col-12'}
              label={i18n.t<string>('core.update')}
            />
          </div>
        </form>
      </FormProvider>
      <Toast ref={toast} position={'bottom-right'} />
    </div>
  )
}